export const DisabledPermissionsForMobileEnum = [
  'EPOSLOVANJE',
  'RACUNI'
]



// WEBPACK FOOTER //
// ./src/assets/js/Enum/DisabledPermissionsForMobileEnum.js